import React from 'react';
import { BareSvg } from '@/lib';
import IconClose from '@/assets/icons/ic-x-close.svg';
import IconFile from '@/assets/icons/ic-file.svg';
import IconDownload from '@/assets/icons/ic-download.svg';
import styles from './StanSingleFileDropZonePreview.module.css';
import { downloadFile } from '@/lib/helpers';
import { FileState } from '@/hooks/useFileUpload';

export type StanSingleFileDropZonePreviewProps = {
    file: FileState;
    onDelete: (idx: number) => void;
};

export const StanSingleFileDropZonePreview: React.FC<StanSingleFileDropZonePreviewProps> = ({ file, onDelete }) => {
    const handleDownload = () => {
        downloadFile(file.url || '', file.file.name);
    };

    if (file.status !== 'success') {
        return null;
    }

    return (
        <div className={styles.filePreviewContainer}>
            <div
                key={`preview-${file.file.name}-${file.file.size}-${file.file.lastModified}`}
                className={styles.filePreviewItem}
            >
                <div
                    className='group absolute z-10 flex h-full w-full cursor-pointer items-center justify-center rounded-full p-3 opacity-0 transition-colors transition-opacity duration-150 group-hover:opacity-100 hover:opacity-100'
                    title='Download file'
                    onClick={handleDownload}
                >
                    <div className='bg-brand-subtle flex h-3/4 w-3/4 items-center justify-center rounded-full p-1'>
                        <BareSvg
                            SvgComponent={IconDownload}
                            width={20}
                            height={20}
                            className='text-brand-main'
                            removeFill
                        />
                    </div>
                </div>
                {file.file.type.startsWith('image') ? (
                    <img
                        src={file.url ? file.url : URL.createObjectURL(file.file)}
                        alt={file.file.name}
                        className={styles.filePreviewImage}
                        onLoad={e => {
                            if (!file.url) {
                                URL.revokeObjectURL((e.target as HTMLImageElement).src);
                            }
                        }}
                    />
                ) : (
                    <div className={styles.filePreviewDefault}>
                        <BareSvg SvgComponent={IconFile} className={styles.filePreviewDefault} width={36} height={36} />
                        <div className='line-clamp-1 overflow-hidden px-1 pb-1 text-xs font-semibold text-ellipsis whitespace-nowrap'>
                            {file.file.name}
                        </div>
                    </div>
                )}
            </div>

            <BareSvg
                SvgComponent={IconClose}
                className={styles.filePreviewDelete}
                removeFill
                tabIndex={0}
                onClick={(e: React.MouseEvent) => {
                    e.stopPropagation();
                    onDelete(0);
                }}
            />
        </div>
    );
};
